<script lang="ts">
	import type { Device, User } from "luxedo-data"
	import { LuxedoRPC } from "luxedo-rpc"
	import { openConfirmOverlay } from "overlay"
	import { Toast } from "toaster"
	import { TrashIcon } from "luxedo-icons"
	import { viewUser } from "../../../../modules/page-events/navigator"

	interface Props {
		device: Device
		owners: Array<User>
		updateOwners: () => void
	}

	let { device, owners, updateOwners }: Props = $props()

	function removeOwnerClick(owner: User) {
		openConfirmOverlay(
			{
				invertWarning: true,
				prompt: "Are you sure you want to unregister this device?",
				buttons: {
					confirm: {
						text: "Yes",
						onClick: async () => {
							try {
								await LuxedoRPC.api.admin.device_detach_admin(
									device.id,
									owner.id
								)
								Toast.success("Ownership removed!")
							} catch (e) {
								console.error("Unable to remove ownership.", { e })
								Toast.error("Unable to remove ownership at this time.")
							}
							updateOwners()
						},
					},
				},
			},
			{
				heading: "Remove Ownership",
			}
		)
	}
</script>

<div class="flex-column center-hor center-ver">
	{#each owners as owner}
		<div
			class="owner-row"
			role="button"
			tabindex="0"
			onkeydown={(e) => {
				if (e.key === "Enter") viewUser(owner)
			}}
			onclick={() => viewUser(owner)}
		>
			{`${owner.lastname}, ${owner.firstname}`}
			<div class="button-container">
				<button
					class="small cancel only-icon"
					title="Remove Ownership"
					onclick={(e) => {
						e.stopPropagation()
						removeOwnerClick(owner)
					}}><TrashIcon /></button
				>
			</div>
		</div>
	{/each}
</div>

<style>
	.owner-row {
		margin: 0.1rem 0;
		width: 12rem;
		font-size: var(--text-small);
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		border-radius: var(--br);
		padding: 0.2rem 0 0.2rem 0.5rem;
	}

	.owner-row {
		cursor: pointer;
		background-color: var(--color-accent);
		color: var(--color-text-light);
		transition:
			background-color var(--transition-duration),
			color var(--transition-duration);
	}

	.owner-row:hover,
	.owner-row:focus-visible {
		background-color: var(--color-main);
		color: var(--color-text);
	}

	.owner-row:has(:global(button:hover)) {
		background-color: var(--color-accent);
		color: var(--color-text-light);
	}

	.button-container {
		width: fit-content;
	}

	.button-container button {
		margin: 0 0.25rem;
		padding: 0.25rem;
	}

	.button-container button :global(svg) {
		max-height: 1rem;
		max-width: 1rem;
		height: 1rem;
		width: auto;
	}
</style>
